import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSparkarComponent } from './simple-icons-sparkar.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSparkarComponent ],
    exports:      [ SimpleIconsSparkarComponent ],
    bootstrap:    []
})
export class SimpleIconsSparkarModule {}
